/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (retailerSalesTypes) => ({
    type: actions.CONNECTION_RETAILER_SALES_TYPES_RECEIVE,
    payload: { retailerSalesTypes },
});